module.exports = __webpack_public_path__ + "static/media/stock2.9faa0d22.png";